module.exports = __webpack_public_path__ + "static/media/icon_back_orange.22398f19.svg";